import { motion } from "framer-motion";
import styled from "styled-components";
import FramerMotion from "../assets/Images/framer-motion.png";

import {
  SiHtml5,
  SiCss3,
  SiReact,
  SiJavascript,
  SiBootstrap,
  SiTailwindcss,
  SiStyledcomponents
} from "react-icons/si";

const SkillContainer = styled.div`
  position: fixed;
  bottom: 0%;
  right: -10%;
  overflow: hidden;
  cursor: grab;
  width: 70vw;
  color: ${(props) => `rgba(${props.theme.textRgba}, 0.8)`};
  font-size: calc(2rem + 5vw);
  z-index: 2;

  .skill {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo {
    padding: 1rem;
  }

  .sized {
    font-size: calc(1rem + 5vw);
  }

  .large {
    font-size: calc(4rem + 5vw);
  }

  .imgLogo {
    padding-left: 1rem;
    height: auto;
    width: 6vw;
  }

  @media (max-width: 1024px) {
    width: 90vw;

    .logo {
      padding: 0.4rem;
    }

    .imgLogo {
      padding-left: 0.4rem;
    }
  }

  @media (max-width: 600px) {
    width: 120vw;
    right: -21%;
    font-size: calc(4rem + 4vw);

    .sized {
      font-size: calc(3rem + 4vw);
    }

    .large {
      font-size: calc(5rem + 6vw);
    }

    .imgLogo {
      width: 10vw;
    }
  }
`;

const Skills = () => {
  return (
    <SkillContainer>
      <motion.div
        initial={{ transform: "scale(0)" }}
        animate={{ scale: [0, 0.9, 1.05, 1] }}
        transition={{ type: "spring", duration: 2, delay: 1.3 }}
        drag="x"
        dragConstraints={{ right: 0, left: 0 }}
        className="skill"
      >
        <SiReact className="logo" />
        <SiStyledcomponents className="logo large" />
        <SiTailwindcss className="logo" />
        <SiBootstrap className="logo" />
        <SiJavascript className="logo sized" />
        <SiCss3 className="logo sized" />
        <SiHtml5 className="logo sized" />
        <img src={FramerMotion} className="imgLogo" alt="Framer Motion" />
      </motion.div>
    </SkillContainer>
  );
};
export default Skills;
